import { useCallback, useContext, useEffect, useState } from "react";
import { groupDetail, groupMemberDelete, makeGroupMemberAdmin } from "./MessageService";
import ERROR_LIST from "../../../Services/Global-Services/Hadle_Errors";
import { TostMsg } from "../../../App";
import moment from "moment";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
const defaultImage = "/images/placeholder_profile.png";

const MessagesDetail = ({ currentGroup, currentPage }) => {
  let userDetails = JSON.parse(localStorage.getItem("User") || "{}");
  const [groupDetailData, setGroupDetailData] = useState([]);
  const toster = useContext(TostMsg);
  const history = useHistory();
  
  useEffect(() => {
    if (currentGroup) {
      getGroupInfo();
    }
  }, [currentGroup]);

  const changePageType = (groupDetailData) => {
    currentPage("groupEdit", groupDetailData);
  };

  const handleImageError = useCallback((event) => {
    event.target.src = defaultImage;
  }, []);

  async function getGroupInfo() {
    const params = {
      GroupId: currentGroup?.Id,
      OrgId: userDetails?.OrgId,
    };
    try {
      let chatsData = await groupDetail(params);
      setGroupDetailData(chatsData?.Data?.Data);
    } catch (error) {
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  async function makeAdmin(member, type) {
    const params = {
      GroupId: currentGroup?.Id,
      MemberId: member?.MemberId,
    };
    try {
      let AdminData = await makeGroupMemberAdmin(params);
      if (AdminData) {
        if (type == 'make_Admin') {
          toster.current.success("Admin added successfully");
        } else {
          toster.current.success("Remove as admin successfully");
        }
      }
      getGroupInfo();
    } catch (error) {
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  async function removeFromGroup(member) {
    const params = {
      GroupId: currentGroup?.Id,
      MemberId: member?.MemberId,
    };
    try {
      let AdminData = await groupMemberDelete(params);
      if (AdminData) {
        toster.current.success("Member deleted successfully");
      }
      getGroupInfo();
      history.push(`/Messages`);
    } catch (error) {
      toster.current.error(ERROR_LIST.DefaultError);
    }
  }

  return (
    <>
      <div className="col-md-9 pl-0">
        <div className="tab-content" id="v-pills-tabContent">
          <div
            className="tab-pane fade show active"
            id="v-pills-home"
            role="tabpanel"
            aria-labelledby="v-pills-home-tab"
            tabIndex={0}
          >
            <div className="create-new-wrap">
              <div className="top-headingtitile">
                <div className="main-detail">
                  <img
                    src={groupDetailData[0]?.IconLogo || defaultImage}
                    onError={handleImageError}
                    className="profilebg"
                  />
                  <div className="text-info">
                    <h3>{groupDetailData[0]?.GroupName}</h3>
                    <p className="grp-info">
                      <span>
                        Owner :{" "}
                        <b>
                          <img src={groupDetailData[0]?.CreatorProfileImage || defaultImage} />
                          {groupDetailData[0]?.Creatorfull_name}
                        </b>
                      </span>
                      <span>
                        Created By :{" "}
                        <b>
                          <img src={groupDetailData[0]?.CreatorProfileImage || defaultImage} />
                          {groupDetailData[0]?.Creatorfull_name}&nbsp;
                        </b>{" "}
                        on&nbsp;&nbsp;
                        <b>
                          {" "}
                          {moment(groupDetailData[0]?.GroupCreationDate).format(
                            "MMM DD YYYY"
                          )}{" "}
                        </b>
                      </span>
                      {groupDetailData[0]?.CanMemberLeave && (
                        <span>
                          <div className="form-group form-checkcss mb-0">
                            <input
                              type="checkbox"
                              className="form-control"
                              checked={groupDetailData[0]?.CanMemberLeave}
                              disabled
                            />
                            <label>Are members allowed to exit?</label></div>
                        </span>
                      )}

                    </p>
                    <p className="des-paragraph">{groupDetailData[0]?.GroupDesc}.</p>
                  </div>
                </div>
                {groupDetailData?.some(item => item.MemberId === userDetails?.EmpId && item.IsAdmin) && <a onClick={() => changePageType(groupDetailData)} style={{ cursor: 'pointer' }}>
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width={14}
                    height={14}
                    fill="currentColor"
                    className="bi bi-pencil"
                    viewBox="0 0 16 16"
                  >
                    <path d="M12.146.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-10 10a.5.5 0 0 1-.168.11l-5 2a.5.5 0 0 1-.65-.65l2-5a.5.5 0 0 1 .11-.168zM11.207 2.5 13.5 4.793 14.793 3.5 12.5 1.207zm1.586 3L10.5 3.207 4 9.707V10h.5a.5.5 0 0 1 .5.5v.5h.5a.5.5 0 0 1 .5.5v.5h.293zm-9.761 5.175-.106.106-1.528 3.821 3.821-1.528.106-.106A.5.5 0 0 1 5 12.5V12h-.5a.5.5 0 0 1-.5-.5V11h-.5a.5.5 0 0 1-.468-.325" />
                  </svg>
                </a>}
              </div>
              <div className="addnew-form">
                <form>
                  <div className="row justify-content-center">
                    <div className="col-md-8">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label>
                            Members
                            <span className="member-count">
                              {groupDetailData.length}
                            </span>
                          </label>
                          <div className="grpmember-list">
                            <ul>
                              {groupDetailData.map((member) => (
                                <>
                                  {member?.IsAdmin == false && (
                                    <li>
                                      <div className="grp-membername">
                                        <img src={member?.MemberProfileImage || defaultImage}
                                          onError={handleImageError} className="me-1" />
                                        <span>{member?.Memberfull_name}</span>
                                      </div>
                                      <div className="grp-member-actions" style={{ cursor: 'pointer' }}>
                                        {member.OwnerId === userDetails?.EmpId && <a
                                          className="make-admin"
                                          onClick={() => makeAdmin(member, 'make_Admin')}
                                        >
                                          <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width={14}
                                            height={14}
                                            fill="currentColor"
                                            className="bi bi-person-check"
                                            viewBox="0 0 16 16"
                                          >
                                            <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7m1.679-4.493-1.335 2.226a.75.75 0 0 1-1.174.144l-.774-.773a.5.5 0 0 1 .708-.708l.547.548 1.17-1.951a.5.5 0 1 1 .858.514M11 5a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
                                            <path d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z" />
                                          </svg>
                                          Make Admin
                                        </a>}
                                        {(member.MemberId !== member.OwnerId) && // Don't allow to remove Owner
                                          (userDetails?.EmpId === member.OwnerId ||
                                            groupDetailData?.some(item => item.MemberId === userDetails?.EmpId && item.IsAdmin)
                                          ) && (member.MemberId !== userDetails?.EmpId) &&
                                          (
                                            <a className="remove"
                                              onClick={() => removeFromGroup(member)}>
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={14}
                                                height={14}
                                                fill="currentColor"
                                                className="bi bi-people"
                                                viewBox="0 0 16 16"
                                              >
                                                <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1zm-7.978-1L7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002-.014.002zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6.936 9.28a6 6 0 0 0-1.23-.247A7 7 0 0 0 5 9c-4 0-5 3-5 4q0 1 1 1h4.216A2.24 2.24 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816M4.92 10A5.5 5.5 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4" />
                                              </svg>
                                              Remove From Group
                                            </a>)}
                                      </div>
                                    </li>)}
                                  {member?.IsAdmin == true && (
                                    <li>
                                      <div className="grp-membername">
                                        <img src={member?.MemberProfileImage || defaultImage}
                                          onError={handleImageError} className="me-1" />
                                        <span>
                                          {member?.Memberfull_name}
                                          <span className="role">
                                            <span />
                                            Admin
                                          </span>
                                        </span>
                                      </div>
                                      <div className="grp-member-actions" style={{ cursor: 'pointer' }}>
                                        {member.OwnerId === userDetails?.EmpId &&
                                          <>
                                            {member.OwnerId !== member.MemberId && <a className="remove-asadmin" onClick={() => makeAdmin(member, 'remove_admin')}>
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={14}
                                                height={14}
                                                fill="currentColor"
                                                className="bi bi-person-dash"
                                                viewBox="0 0 16 16"
                                              >
                                                <path d="M12.5 16a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M11 12h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1 0-1m0-7a3 3 0 1 1-6 0 3 3 0 0 1 6 0M8 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4" />
                                                <path d="M8.256 14a4.5 4.5 0 0 1-.229-1.004H3c.001-.246.154-.986.832-1.664C4.484 10.68 5.711 10 8 10q.39 0 .74.025c.226-.341.496-.65.804-.918Q8.844 9.002 8 9c-5 0-6 3-6 4s1 1 1 1z" />
                                              </svg>
                                              Remove As Admin
                                            </a>}
                                          </>
                                        }
                                        {(member.MemberId !== member.OwnerId) && // Don't allow to remove Owner
                                          (userDetails?.EmpId === member.OwnerId ||
                                            groupDetailData?.some(item => item.MemberId === userDetails?.EmpId && item.IsAdmin)
                                          ) && (member.MemberId == userDetails?.EmpId) &&
                                          (
                                            <a className="remove" onClick={() => removeFromGroup(member)}>
                                              <svg
                                                xmlns="http://www.w3.org/2000/svg"
                                                width={14}
                                                height={14}
                                                fill="currentColor"
                                                className="bi bi-people"
                                                viewBox="0 0 16 16"
                                              >
                                                <path d="M15 14s1 0 1-1-1-4-5-4-5 3-5 4 1 1 1 1zm-7.978-1L7 12.996c.001-.264.167-1.03.76-1.72C8.312 10.629 9.282 10 11 10c1.717 0 2.687.63 3.24 1.276.593.69.758 1.457.76 1.72l-.008.002-.014.002zM11 7a2 2 0 1 0 0-4 2 2 0 0 0 0 4m3-2a3 3 0 1 1-6 0 3 3 0 0 1 6 0M6.936 9.28a6 6 0 0 0-1.23-.247A7 7 0 0 0 5 9c-4 0-5 3-5 4q0 1 1 1h4.216A2.24 2.24 0 0 1 5 13c0-1.01.377-2.042 1.09-2.904.243-.294.526-.569.846-.816M4.92 10A5.5 5.5 0 0 0 4 13H1c0-.26.164-1.03.76-1.724.545-.636 1.492-1.256 3.16-1.275ZM1.5 5.5a3 3 0 1 1 6 0 3 3 0 0 1-6 0m3-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4" />
                                              </svg>
                                              Remove From Group
                                            </a>)}
                                      </div>
                                    </li>)}
                                </>
                              ))}
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default MessagesDetail;
